import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, ColorPicker, Field } from '@itds/elements/index.js';
import { Colors } from '@itds/Theme';

const ThemeOptions = ({ updateWebsiteQuoter, website_quoter }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    setData({
      primary_color: website_quoter.primary_color,
      secondary_color: website_quoter.secondary_color
    });
  }, [website_quoter]);

  const handleColorChange = (name, color) => {
    setData({ ...data, [name]: color.hex });
  };

  const handleSave = () => {
    updateWebsiteQuoter(data);
  };

  return (
    <div>
      <Field>
        <ColorPicker
          color={{ hex: data.primary_color || Colors.SECONDARY.hex }}
          label='Primary Color'
          onChange={handleColorChange.bind(null, 'primary_color')}
        />
      </Field>

      <Field>
        <ColorPicker
          color={{ hex: data.secondary_color || Colors.PRIMARY.hex }}
          label='Secondary Color'
          onChange={handleColorChange.bind(null, 'secondary_color')}
        />
      </Field>

      <div style={{ display: 'flex', marginTop: 30 }}>
        <Button onClick={handleSave}>Save</Button>
      </div>
    </div>
  );
};

ThemeOptions.propTypes = {
  updateWebsiteQuoter: PropTypes.func,
  website_quoter: PropTypes.object
};

export default ThemeOptions;
